import { render, staticRenderFns } from "./HomePageProductNew.vue?vue&type=template&id=fbd521c0&scoped=true&"
import script from "./HomePageProductNew.vue?vue&type=script&lang=js&"
export * from "./HomePageProductNew.vue?vue&type=script&lang=js&"
import style0 from "./HomePageProductNew.vue?vue&type=style&index=0&id=fbd521c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbd521c0",
  null
  
)

export default component.exports